import React, { FC, useEffect, useState } from "react";
import { ScheduleData } from "../../interface/schedule";

import { Box, Button, Stack, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { useTheme } from "@mui/material/styles";
import { btnSty } from "../ui-styles";
import ScheduleInformation from "./scheduleInformation";
import { ShiftTypeModal } from "./ScheduleModal";
import { useMutation } from "@tanstack/react-query";
import { apiGetEmploymentsByFacility } from "../../api/employment";
import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../notification";
import { EmploymentDetailsProps } from "../../interface/employment";

const ScheduleDetailsContent: FC<{
  scheduleInfo: ScheduleData;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ scheduleInfo, setRefresh }) => {
  const isSmall = useResponsive("down", "sm", "xl");
  const theme = useTheme();
  const { showNotification } = useNotificationService();
  const [employment_list, setEmployment_list] = useState<
    EmploymentDetailsProps[]
  >([]);

  const [openShift, setOpenShift] = useState(false);
  const handleShiftType = () => {
    setOpenShift(!openShift);
  };
  useEffect(() => {
    mutation.mutate();
  }, []);
  const mutation = useMutation({
    mutationFn: () => apiGetEmploymentsByFacility("", ""),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        if (data?.data?.data?.length > 0) {
          setEmployment_list(data.data.data);
        } else {
          setEmployment_list([]);
        }
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });
  return (
    <Box sx={{ padding: 3 }}>
      <ShiftTypeModal
        open={openShift}
        setRefresh={setRefresh}
        closeModal={handleShiftType}
        handleModal={handleShiftType}
        scheduleId={scheduleInfo._id}
        employeeList={employment_list}
        loading={mutation.isPending}
        start={scheduleInfo?.start_date}
        end={scheduleInfo?.end_date}
      />

      <Stack
        direction={isSmall ? "column" : "row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ paddingX: 2, mt: 3 }}
      >
        <Typography
          variant="subtitle2"
          color={"neutral"}
          sx={{ fontWeight: 700, fontFamily: "Inter" }}
        >
          Schedule Information
        </Typography>
        <Stack
          direction={isSmall ? "column" : "row"}
          sx={{ gap: isSmall ? 2 : 4, my: 2 }}
        >
          <Button
            onClick={handleShiftType}
            sx={{
              ...btnSty,
              color: theme.palette.neutral.main,
            }}
          >
            <img
              src="/assets/icons/add-circle.svg"
              alt="icon"
              width={22}
              height={22}
            />
            Create New Shift Type
          </Button>
        </Stack>
      </Stack>

      <ScheduleInformation
        mode={"List"}
        closeModal={() => {}}
        scheduleInfo={scheduleInfo}
        setRefresh={setRefresh}
      />
    </Box>
  );
};

export default ScheduleDetailsContent;
